import useAuth from "@/hooks/useAuth";
import { cn } from "@/lib/utils";
import ClassCubeLogo from "./ClassCubeLogo";

type Props = {
  className?: string;
};

const Loader = ({ className }: Props) => {
  const { school } = useAuth()

  return (
    <div
      className={cn(
        "grid min-h-[50vh] w-full items-center justify-center",
        className,
      )}
    >
      {school ?
        <img src={school?.logo} alt="" /> :
        <ClassCubeLogo className="animate-pulse" />
      }
    </div>
  );
};

export const AppLoader = ({ className }: Props) => {
  return (
    <div
      className={cn(
        "grid min-h-[50vh] w-full items-center justify-center",
        className,
      )}
    >
      <ClassCubeLogo className="animate-pulse" />
    </div>
  );
};

export default Loader;
